import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SigmaIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z" fill="currentColor" />
  </svg>
);

SigmaIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SigmaIcon);
